module.exports = __webpack_public_path__ + "static/media/direct.1c942e3f.gif";